<template>
  <widgetModal :title="!email_form.id ? 'New Email' : 'Compose email'"
    subtitle="You can add information directly from this form" btnlefttext="Send" btncentertext="Cancel"
    btnrighttext="Save as draft" :leftloading="send_email_loading" :rightloading="save_email_loading"
    :centerloading="false" :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px"
    body_padding="0px 20px" width="580px" :loading="signature_loading" @onLeftClick="sendEmail()"
    @onCenterClick="onCancel" @onRightClick="saveEmailAsDraft()">
    <div class="widget-modal-body-noscoll">
      <widgetInputWrapper title="Send to*">
        <widgetEmailRecipientInput v-model="email_form.recipients" :maxRecipients="50"
          placeholder="Enter email addresses..." />
      </widgetInputWrapper>
      <widgetInputWrapper title="Subject*">
        <widgetInput v-model="email_form.title" type="text" placeholder="Add Your Subject"></widgetInput>
      </widgetInputWrapper>
      <widgetInputWrapper title="Message*">
        <html-editor placeholder="Type here..." v-model="email_form.message" id="edit-descr" />
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>

<script>
import WidgetEmailRecipientInput from './widgetEmailRecipientInput.vue';
export default {
  name: "",
  components: {
    WidgetEmailRecipientInput
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    template: {
      type: Object,
      default: null,
    },
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      send_email_loading: false,
      save_email_loading: false,
      email_form: {
        id: null,
        title: "",
        recipients: [],
        action: "other",
        message: "",
      },
      signature_loading: false,
    };
  },
  mounted() {
    let vm = this;
    if (vm.template) {
      vm.updateWithTemplate(vm.template);
      vm.getDefaultSignature();
    } else {
      if (vm.value) {
        vm.updateEmail(vm.value);
      } else {
        vm.newEmail();
        vm.getDefaultSignature();
      }
    }

  },
  computed: {},
  watch: {},
  methods: {
    getDefaultSignature() {
      let vm = this;
      vm.signature_loading = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_GET_DEFAULT_SIGNATURE")
        .then((res) => {
          vm.signature_loading = false;
          if (!vm.email_form.id) {
            if (vm.template) {
              vm.email_form.message =
                vm.email_form.message + "<br><br>" + res.data.message;
            } else {
              vm.email_form.message = "<br><br>" + res.data.message;
            }
          } else {
            vm.email_form.message =
              vm.email_form.message + "<br><br>" + res.data.message;
          }
        })
        .catch((err) => {
          vm.signature_loading = false;
        });
    },
    updateWithTemplate(item) {
      let vm = this;
      vm.email_form = {
        id: null,
        title: item.title,
        phase: "",
        recipients: [],
        action: "",
        message: item.description,
      };
    },
    updateEmail(item) {
      let vm = this;
      vm.email_form.id = item.id;
      vm.email_form.title = item.title;
      vm.email_form.phase = item.phase;
      vm.email_form.message = item.description;
      vm.email_form.action = item.action;

    },
    newEmail() {
      let vm = this;
      vm.email_form = {
        id: null,
        title: "",
        phase: "",
        recipients: [],
        action: "other",
        message: "",
      };
    },
    sendEmail() {
      let vm = this;
      const rules = {
        recipients: {
          run: (value) => {
            if (value.length === 0) {
              return "Please add at least one recipient";
            }
            return false;
          },
        },
        title: {
          run: (value) => {
            if (!value) {
              return "Please add email subject";
            }
            return false;
          },
        },
        message: {
          run: (value) => {
            if (!value) {
              return "Please add email message";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.email_form, rules)) {
        vm.send_email_loading = true;
        vm.email_form.phase = vm.phase;
        vm.$store
          .dispatch("EMAIL_SEND_NEW_EMAIL", vm.email_form)
          .then((responce) => {
            vm.send_email_loading = false;
            vm.$emit("emailSent", vm.email_form);
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Email sent successfully",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.send_email_loading = false;
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Email sending failed",
              type: "warn",
              duration: 3000,
            });
          });

      }
    },
    saveEmailAsDraft() {
      let vm = this;
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Please add email subject";
            }
            return false;
          },
        },
        message: {
          run: (value) => {
            if (!value) {
              return "Please add email message";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.email_form, rules)) {
        vm.email_form.phase = vm.phase;
        if (!vm.email_form.id) {
          vm.save_email_loading = true;
          vm.$store
            .dispatch("EMAIL_SAVE_AS_NEW_DRAFT", vm.email_form)
            .then((responce) => {
              vm.save_email_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Email is now added",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.save_email_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something wrong while adding email",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          vm.save_email_loading = true;
          vm.$store
            .dispatch("EMAIL_UPDATE_DRAFT", vm.email_form)
            .then((responce) => {
              vm.save_email_loading = false;
              vm.$emit("saved");
              vm.$notify({
                group: "status",
                title: "Success",
                text: "Email is now updated",
                type: "success",
                duration: 3000,
              });
            })
            .catch((error) => {
              vm.save_email_loading = false;
              vm.$notify({
                group: "status",
                title: "Warning",
                text: "Something wrong while updating email",
                type: "warn",
                duration: 3000,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
</style>
